import { LogEntry, Response } from 'lib-shared-legacy-types';

import { ajaxSend } from '../../../api/api';

type GetActivityLogResponse = Response<{
  activity_log: LogEntry[];
}>;

/**
 * Gets the activity logs for a conversation.
 *
 * @param csid The conversation id.
 */
export function getActivityLog(csid: number): Promise<GetActivityLogResponse> {
  return ajaxSend<GetActivityLogResponse>({
    path: `/v1/conversations/${csid}/activity_log`,
  });
}
